import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import InfiniteScroll from 'react-infinite-scroller';
import { Button } from 'react-bootstrap';

import Note from './Note.jsx';

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? '#FAFAFA' : 'transparent'
  //padding: grid,
  //width: 250
});

@inject('rootStore')
@observer
export default class Notes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxHeight: false,
      hasScroll: false
    };
  }

  render() {
    const { lane, notes, provided, snapshot } = this.props;
    const maxHeightClass = this.state.maxHeight ? 'notes-max-height' : '';
    const expandButtonClass = this.state.maxHeight
      ? 'fa fa-chevron-up'
      : 'fa fa-chevron-down';
    const hiddenVisibilityClass = this.state.hasScroll
      ? ''
      : 'hidden-visibility';
    const scrollStyle = { marginRight: this.state.hasScroll ? '10px' : '' };

    const loader = <div key={lane.id} className="loader" />;

    return (
      <div>
        <ul
          className={`notes-container ${maxHeightClass}`}
          ref={input => {
            provided.innerRef(input);
            this.notesUlRef = input;
          }}
          style={getListStyle(snapshot.isDraggingOver)}
          key={lane.id}
        >
          <InfiniteScroll
            pageStart={1}
            loadMore={this.handleLoadMore}
            hasMore={lane.hasMoreNotes}
            loader={loader}
            useWindow={false}
            initialLoad={false}
            style={scrollStyle}
          >
            {notes.map((note, index) => (
              <Note note={note} key={note.id} index={index} />
            ))}
          </InfiniteScroll>
        </ul>

        <div>
          <Button
            bsStyle="default"
            block
            className={`lane-expand-btn ${expandButtonClass} ${hiddenVisibilityClass}`}
            onClick={e => {
              this.setState({ maxHeight: !this.state.maxHeight });
            }}
          />
        </div>
      </div>
    );
  }

  // scrollToNotesBottom = () => {
  //     this.notesUlRef.scrollTop = this.notesUlRef.scrollHeight;
  // };

  handleLoadMore = page => {
    if (!this.props.rootStore.isInclusiveBoard)
      this.props.lane.loadMoreNotes(page);
  };

  componentWillReceiveProps() {
    if (this.notesUlRef.scrollHeight > this.notesUlRef.clientHeight) {
      this.setState({ hasScroll: true });
    } else {
      this.setState({ hasScroll: false, maxHeight: false });
    }
  }
}
